<template>
  <div>
    <h3>{{ message }}</h3>
    <button @click="fetchData">获取后端数据</button>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      message: '123nihao'
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const res = await fetch(`${process.env.VUE_APP_API_BASE}/hello`)
        const text = await res.text()
        this.message = text
      } catch (err) {
        this.message = '请求失败: ' + err.message
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
